import useLocalStorageState from 'use-local-storage-state'

export const useDogFormClear = () => {
	return useLocalStorageState('dogFormClear', {
		defaultValue: false,
	})
}
